/**
 * 路由配置 会议
 * key需要与后台返回的 module_url 对应
 */

import store from '@/store';

export default () => {
    let { domain } = store.state.meetingInfo;
    return {
        Index: {
            path: '/index/:lang/:meeting_id',
            component: () => import(/* webpackChunkName: "Index" */ '../views/index.vue')
        },

        /**************  会议配置  ****************/
        // 会议基本信息配置
        MeetingConfigInfo: {
            path: '/meeting-config/info/:lang/:meeting_id',
            component: () => import(/* webpackChunkName: "MeetingConfigInfo" */ '../views/meeting-config/info.vue')
        },
        // 默认首页设置
        MeetingConfigDefaultPage: {
            path: '/meeting-config/default-page/:lang/:meeting_id',
            component: () => import(/* webpackChunkName: "MeetingConfigDefaultPage" */ '../views/meeting-config/default-page.vue')
        },

        /**************  PC网站配置 -  ****************/
        // 默认图片设置
        MeetingConfigImagePageCn: {
            path: '/meeting-config/cn-default-image/:lang/:meeting_id',
            component: () => import(/* webpackChunkName: "MeetingConfigImagePage" */ '../views/meeting-config/default-image.vue')
        },

        // 网站基本配置
        WebConfigInfoCn: {
            path: '/web-config/cn-info/:lang/:meeting_id',
            component: () => import('../views/web-config/info.vue')
        },
        // 模版风格配置
        WebConfigStyleCn: {
            path: '/web-config/cn-style/:lang/:meeting_id',
            component: () => import('../views/web-config/style.vue')
        },
        // 首页栏目配置
        WebConfigPageContentCn: {
            path: '/web-config/cn-page-content/:lang/:meeting_id',
            component: () => import('../views/web-config/page-content.vue')
        },
        // 导航栏目配置
        WebConfigNavListCn: {
            path: '/web-config/cn-nav-list/:lang/:meeting_id',
            component: () => import('../views/web-config/nav-list.vue')
        },

        /**************  PC网站配置 - 英文  ****************/
        // 默认图片设置
        MeetingConfigImagePageEn: {
            path: '/meeting-config/en-default-image/:lang/:meeting_id',
            component: () => import(/* webpackChunkName: "MeetingConfigImagePageEn" */ '../views/meeting-config/default-image.vue')
        },
        // 网站基本配置
        WebConfigInfoEn: {
            path: '/web-config/en-info/:lang/:meeting_id',
            component: () => import('../views/web-config/info.vue')
        },
        // 模版风格配置
        WebConfigStyleEn: {
            path: '/web-config/en-style/:lang/:meeting_id',
            component: () => import('../views/web-config/style.vue')
        },
        // 首页栏目配置
        WebConfigPageContentEn: {
            path: '/web-config/en-page-content/:lang/:meeting_id',
            component: () => import('../views/web-config/page-content.vue')
        },
        // 导航栏目配置
        WebConfigNavListEn: {
            path: '/web-config/en-nav-list/:lang/:meeting_id',
            component: () => import('../views/web-config/nav-list.vue')
        },

        /**************  Mobile网站配置 - 中文  ****************/
        // 基本配置
        MobileConfigInfoCn: {
            path: '/mobile-config/cn-info/:lang/:meeting_id',
            component: () => import('../views/mobile-config/info.vue')
        },
        // 风格配置
        MobileConfigStyleCn: {
            path: '/mobile-config/cn-style/:lang/:meeting_id',
            component: () => import('../views/mobile-config/style.vue')
        },
        // 顶部轮播配置
        MobileConfigBannerCn: {
            path: '/mobile-config/cn-banner/:lang/:meeting_id',
            component: () => import('../views/mobile-config/banner.vue')
        },
        // 导航栏目配置
        MobileConfigNavListCn: {
            path: '/mobile-config/cn-nav-list/:lang/:meeting_id',
            component: () => import('../views/mobile-config/nav-list.vue')
        },
        // 广告配置
        MobileConfigAdCn: {
            path: '/mobile-config/cn-ad/:lang/:meeting_id',
            component: () => import('../views/mobile-config/advertising.vue')
        },
        // 分享配置
        MobileConfigShareCn: {
            path: '/mobile-config/cn-share/:lang/:meeting_id',
            component: () => import('../views/mobile-config/share.vue')
        },
        /**************  Mobile网站配置 - 英文  ****************/
        // 基本配置
        MobileConfigInfoEn: {
            path: '/mobile-config/en-info/:lang/:meeting_id',
            component: () => import('../views/mobile-config/info.vue')
        },
        // 风格配置
        MobileConfigStyleEn: {
            path: '/mobile-config/en-style/:lang/:meeting_id',
            component: () => import('../views/mobile-config/style.vue')
        },
        // 顶部轮播配置
        MobileConfigBannerEn: {
            path: '/mobile-config/en-banner/:lang/:meeting_id',
            component: () => import('../views/mobile-config/banner.vue')
        },
        // 导航栏目配置
        MobileConfigNavListEn: {
            path: '/mobile-config/en-nav-list/:lang/:meeting_id',
            component: () => import('../views/mobile-config/nav-list.vue')
        },
        // 广告配置
        MobileConfigAdEn: {
            path: '/mobile-config/en-ad/:lang/:meeting_id',
            component: () => import('../views/mobile-config/advertising.vue')
        },
        // 分享配置
        MobileConfigShareEn: {
            path: '/mobile-config/en-share/:lang/:meeting_id',
            component: () => import('../views/mobile-config/share.vue')
        },
        /**************  商品管理  ****************/
        // 销售统计
        GoodsModuleStatistics: {
            path: '/goods/statistics/:lang/:meeting_id',
            component: () => import('../views/goods-module/statistics.vue')
        },
        // 商品管理
        GoodsModuleGoods: {
            path: '/goods/goods/:lang/:meeting_id',
            component: () => import('../views/goods-module/goods.vue')
        },
        // 分类管理
        GoodsModuleClassify: {
            path: '/goods/classify/:lang/:meeting_id',
            component: () => import('../views/goods-module/classify.vue')
        },
        // 订单管理
        OrderModuleIndex: {
            path: '/goods/order/:lang/:meeting_id',
            component: () => import('../views/goods-module/order-list.vue')
        },
        // 发票列表管理
        OrderInvoiceList: {
            path: '/goods/invoice-list/:lang/:meeting_id',
            component: () => import('../views/goods-module/invoice-list.vue')
        },
        /**************  促销管理  ****************/
        // 阶梯促销
        GoodsModuleLadderPromotion: {
            path: '/goods/ladder-promotion/:lang/:meeting_id',
            component: () => import('../views/goods-module/promotion/ladder-promotion.vue')
        },
        // 满减促销
        GoodsModuleMaxOutPromotion: {
            path: '/goods/max-out-promotion/:lang/:meeting_id',
            component: () => import('../views/goods-module/promotion/max-out-promotion.vue')
        },
        // 满件促销
        GoodsModuleMaxFullPromotion: {
            path: '/goods/max-full-promotion/:lang/:meeting_id',
            component: () => import('../views/goods-module/promotion/max-full-promotion.vue')
        },
        // 搭配促销
        GoodsModuleMatchPromotion: {
            path: '/goods/match-promotion/:lang/:meeting_id',
            component: () => import('../views/goods-module/promotion/match-promotion.vue')
        },
        // 优惠券
        GoodsModuleDiscountPromotion: {
            path: '/goods/discount-promotion/:lang/:meeting_id',
            component: () => import('../views/goods-module/promotion/discount-promotion.vue')
        },
        // 营销规则
        GoodsModuleMarketingRule: {
            path: '/goods/marketing-rule/:lang/:meeting_id',
            component: () => import('../views/goods-module/marketing-rules.vue')
        },
        // 渠道推广
        GoodsModuleChannel: {
            path: '/goods/channel/:lang/:meeting_id',
            component: () => import('../views/goods-module/channel.vue')
        },

        /**************  用户管理  ****************/
        // 参会用户
        // 中宾用户管理
        UserModuleIndexCn: {
            path: '/user/meeting-form-cn/:lang/:meeting_id',
            component: () => import('../views/user-module/index.vue')
        },
        // 外宾用户管理
        UserModuleIndexEn: {
            path: '/user/meeting-form-en/:lang/:meeting_id',
            component: () => import('../views/user-module/index.vue')
        },
        // 注册表单设置
        MeetingConfigFormEn: {
            path: '/meeting-config/en-form/:lang/:meeting_id',
            component: () => import(/* webpackChunkName: "MeetingConfigFormEn" */ '../views/form-config/form.vue')
        },
        // 注册表单设置
        MeetingConfigFormCn: {
            path: '/meeting-config/cn-form/:lang/:meeting_id',
            component: () => import(/* webpackChunkName: "MeetingConfigFormCn" */ '../views/form-config/form.vue')
        },
        //身份验证配置
        // UserModuleIdentity: {
        //     path: '/user/identity/:lang/:meeting_id',
        //     component: () => import('../views/user-module/identity.vue')
        // },

        // 参会身份管理
        UserIdentity: {
            path: '/user/user-identity/:lang/:meeting_id',
            component: () => import('../views/user-module/user-identity.vue')
        },
        // 参会待遇管理
        UserTreatment: {
            path: '/user/user-treatment/:lang/:meeting_id',
            component: () => import('../views/user-module/user-treatment.vue')
        },
        // 注册参数-中宾注册参数
        UserParamsConfigCn: {
            path: '/user/params-config-cn/:lang/:meeting_id',
            component: () => import('../views/user-module/user-params-config.vue')
        },
        // 注册参数-外宾注册参数
        UserParamsConfigEn: {
            path: '/user/params-config-en/:lang/:meeting_id',
            component: () => import('../views/user-module/user-params-config.vue')
        },
        // vip用户管理
        UserModuleVipIndexCn: {
            path: '/user/vip-list-cn/:lang/:meeting_id',
            component: () => import('../views/user-module/vip/index.vue')
        },
        UserModuleVipIndexEn: {
            path: '/user/vip-list-en/:lang/:meeting_id',
            component: () => import('../views/user-module/vip/index.vue')
        },
        /**************  工作人员管理  ****************/
        // 中宾管理
        StaffModuleIndexCn: {
            path: '/staff/index-cn/:lang/:meeting_id',
            component: () => import('../views/staff-module/index.vue')
        },
        // 外宾管理
        StaffModuleIndexEn: {
            path: '/staff/index-en/:lang/:meeting_id',
            component: () => import('../views/staff-module/index.vue')
        },

        // 基本信息配置
        StaffModuleConfig: {
            path: '/staff/config/:lang/:meeting_id',
            component: () => import('../views/staff-module/config.vue')
        },
        // 工作岗位管理
        StaffModuleJob: {
            path: '/staff/job/:lang/:meeting_id',
            component: () => import('../views/staff-module/job.vue')
        },
        // 工作人员表单配置-中宾
        WorkerFormConfigCn: {
            path: '/user/worker-form-cn/:lang/:meeting_id',
            component: () => import('../views/form-config/form.vue')
        },
        // 工作人员表单配置-外宾
        WorkerFormConfigEn: {
            path: '/user/worker-form-en/:lang/:meeting_id/',
            component: () => import('../views/form-config/form.vue')
        },
        /***************   论坛管理  ***************/
        // 论坛管理
        ForumModuleIndex: {
            path: '/forum/index/:lang/:meeting_id',
            component: () => import('../views/forum-module/index.vue')
        },
        /*****************支付方式配置&发票管理*************/
        // 中宾支付
        PaymentCnSetting: {
            path: '/goods/payment-setting-cn/:lang/:meeting_id',
            component: () => import('../views/goods-module/payment-setting.vue')
        },
        // 外宾支付
        PaymentEnSetting: {
            path: '/goods/payment-setting-en/:lang/:meeting_id',
            component: () => import('../views/goods-module/payment-setting.vue')
        },
        InvoiceSetting: {
            path: '/goods/invoice-setting/:lang/:meeting_id',
            component: () => import('../views/goods-module/invoice-setting.vue')
        },

        /****** 注册参数配置 ****/
        // 中宾配置
        RegisterSetingCn: {
            path: '/goods/register-setting-cn/:lang/:meeting_id',
            component: () => import('../views/goods-module/register-setting.vue')
        },
        // 外宾配置
        RegisterSetingEn: {
            path: '/goods/register-setting-en/:lang/:meeting_id',
            component: () => import('../views/goods-module/register-setting.vue')
        },
        // 中宾门票退款配置
        RefundCnSetting: {
            path: '/goods/refund-setting-cn/:lang/:meeting_id',
            component: () => import('../views/goods-module/refund-setting.vue')
        },
        // 外宾门票退款配置
        RefundEnSetting: {
            path: '/goods/refund-setting-en/:lang/:meeting_id',
            component: () => import('../views/goods-module/refund-setting.vue')
        },
        /********************  工具管理  *********************/
        ToolList: {
            path: '/tool-module/index/:lang/:meeting_id',
            component: () => import('../views/tool-module/index.vue')
        },
        /*********************  权限  **********************/
        // 权限管理
        AuthorityIndex: {
            path: '/authority/index/:lang/:meeting_id',
            component: () => import('../views/authority-module/user.vue')
        },
        // 论坛管理
        AuthorityForum: {
            path: '/authority/forum/:lang/:meeting_id',
            component: () => import('../views/authority-module/forum.vue')
        },

        /*********************  酒店  **********************/
        // 中宾住宿管理
        // HotelCnPersonal: {
        //     path: "/hotel/index/:lang/:meeting_id",
        //     component: () => import('../views/iframe.vue'),
        //     meta: {
        //         iframe: domain+"/hotel/meeting-hotel/cn/:meeting_id?is_iframe=1",
        //     }
        // },
        // 外宾住宿管理
        // HotelEnPersonal: {
        //     path: "/hotel/en-personal/:lang/:meeting_id",
        //     component: () => import('../views/iframe.vue'),
        //     meta: {
        //         iframe: domain+"/hotel/meeting-hotel/en/:meeting_id?is_iframe=1",
        //     }
        // },
        // 个人发票管理
        HotelInvoice: {
            path: '/hotel/invoice/:lang/:meeting_id',
            component: () => import('../views/hotel-module/hotel-invoice.vue')
        },
        // 酒店退款订单
        HotelOrder: {
            path: '/hotel/order/:lang/:meeting_id',
            component: () => import('../views/hotel-module/hotel-order.vue')
            // component: () => import('../views/iframe.vue'),
            // meta:{
            //     iframe:domain+"/guest/order/cn-hotel-list/:meeting_id?is_iframe=1",
            // }
        },
        // 酒店房型管理
        HotelRoom: {
            path: '/hotel/room/:lang/:meeting_id',
            component: () => import('../views/hotel-module/hotel-type.vue')
        },
        // 住宿参数配置
        HotelParams: {
            path: '/hotel/params/:lang/:meeting_id',
            component: () => import('../views/hotel-module/hotel-config.vue')
        },
        // 酒店退款配置
        HotelRefundConfig: {
            path: '/hotel/refund-config/:lang/:meeting_id',
            component: () => import('../views/hotel-module/hotel-refund-config.vue')
        },
        // 酒店住宿统计管理
        // 房间类型统计
        HotelStatistics: {
            path: '/hotel/statistics/:lang/:meeting_id',
            // component: () => import('../views/iframe.vue'),
            component: () => import('../views/hotel-module/hotel-room-statistics.vue')
            // meta:{../views/hotel-module/hotel-room-statistics.vue
            //     iframe:domain+"/count/hotel/types/:meeting_id?is_iframe=1",
            // }
        },
        // 酒店入住/离店统计
        HotelInOutStatistics: {
            path: '/hotel/in-out-statistics/:lang/:meeting_id',
            component: () => import('../views/hotel-module/hotel-In-out-statistics.vue'),
            meta: {
                hide_menu: true
            }
        },
        // 支付配置
        HotelPay: {
            path: '/hotel/pay/:lang/:meeting_id',
            component: () => import('../views/hotel-module/hotel-pay.vue')
        },
        /*********************  日程  **********************/
        // 学术日程管理
        ProgramSession: {
            path: '/program/index/:lang/:meeting_id',
            component: () => import('../views/program-module/program/index.vue')
            // meta: {
            //     iframe: process.env.NODE_ENV == 'production' ? domain + '/program/session/index/:meeting_id?is_iframe=1' : ''
            // }
        },
        // 日程任务列表
        ProgramTaskList: {
            path: '/program/task/:lang/:meeting_id',
            component: () => import('../views/program-module/program/task.vue'),
            meta: {
                hide_menu: true
            }
        },
        // 学术日程配置-发言类型配置
        ProgramCategory: {
            path: '/program/category/:lang/:meeting_id',
            component: () => import('../views/program-module/program-config/speak-config.vue'),
            meta: {
                iframe: process.env.NODE_ENV == 'production' ? domain + '/program/category/list/:meeting_id?is_iframe=1' : ''
            }
        },
        // 学术日程配置-主持人类型配置
        ProgramCompereConfig: {
            path: '/program/compere-config/:lang/:meeting_id',
            component: () => import('../views/program-module/program-config/compere-config.vue')
        },
        // 学术日程配置-讨论类型配置
        ProgramDiscussConfig: {
            path: '/program/discuss-config/:lang/:meeting_id',
            component: () => import('../views/program-module/program-config/discuss-config.vue')
        },
        // 学术日程配置-日程显示配置
        ProgramViewConfig: {
            path: '/program/view-config/:lang/:meeting_id',
            component: () => import('../views/program-module/program-config/view-config.vue')
        },
        // 学术日程配置-幻灯系统配置
        ProgramSlideConfig: {
            path: '/program/slide-config/:lang/:meeting_id',
            component: () => import('../views/program-module/program-config/slide-config.vue')
        },
        // 学术日程配置-日程添加次数限制
        ProgramAddLimit: {
            path: '/program/add-limit/:lang/:meeting_id',
            component: () => import('../views/program-module/program-config/add-limit.vue')
        },
        // 学术任务确认-学术任务确认管理
        ProgramDutyComfirm: {
            path: '/program/duty-comfirm/:lang/:meeting_id',
            component: () => import('../views/program-module/program-duty-comfirm/index.vue')
        },
        // 学术任务管理
        ProgramDutyList: {
            path: '/program/duty-list/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/program/duty/list/:meeting_id?is_iframe=1'
            }
        },
        // 学术任务考勤
        ProgramDutyAttendance: {
            path: '/program/duty-attendance/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/program/duty/duty-attendance/:meeting_id?is_iframe=1'
            }
        },
        // 学术考勤打印
        ProgramPrint: {
            path: domain + '/program/meeting-attendance/index/:meeting_id'
        },
        // 学术日程统计
        ProgramStatistics: {
            path: '/program/statistics/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/program/duty/program-statistics/:meeting_id?is_iframe=1'
            }
        },
        /*********************  展商  **********************/
        // 展览招商申请管理
        ExhibitionApply: {
            path: '/exhibition/apply/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/exhibitor/exhibitor-apply/index/:meeting_id?is_iframe=1'
            }
        },
        // 参展企业信息管理
        ExhibitionCompany: {
            path: '/exhibition/company/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/exhibitor/exhibitor-company-info/company-info-management/:meeting_id?is_iframe=1'
            }
        },
        // 展览招商项目统计
        ExhibitionStatistics: {
            path: '/exhibition/statistics/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/exhibitor/exhibitor-statistics/index-one/:meeting_id?is_iframe=1'
            }
        },
        // 展览招商参数配置
        ExhibitionParams: {
            path: '/exhibition/params/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/exhibitor/exhibitor-set/index-cn/:meeting_id?is_iframe=1'
            }
        },
        // 在线展览展品管理
        ExhibitionProduct: {
            path: '/exhibition/product/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/exhibitor/online-goods/index/:meeting_id?is_iframe=1'
            }
        },
        // 在线展览数据管理
        ExhibitionData: {
            path: '/exhibition/data/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/exhibitor/online-count/all-count/:meeting_id?is_iframe=1'
            }
        },
        // 展位自助选取
        ExhibitionChoice: {
            path: '/exhibition/choice/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/exhibitor/exhibitor-set/booth-set/:meeting_id?is_iframe=1'
            }
        },
        // 在线3D展览制作
        Exhibition3D: {
            path: '/exhibition/3d/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/exhibitor/exhibitor-apply/3d/:meeting_id?is_iframe=1'
            }
        },
        // 招商工作人员管理
        ExhibitionStaff: {
            path: '/exhibition/staff/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/staff/staff/company-info-management/:meeting_id?is_iframe=1'
            }
        },
        // 招商手册管理
        ExhibitionManual: {
            path: '/exhibition/manual/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/meeting/tool/exhibitor/:meeting_id?is_iframe=1'
            }
        },

        /*********************  问卷调查  **********************/
        // 问卷调查
        Survey: {
            path: '/survey/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/survey/list/index/:meeting_id?is_iframe=1',
                hide_menu: true
            }
        },

        /*********************  VIP  **********************/
        // 综合信息管理
        VipItinerary: {
            path: '/vip/itinerary/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/itinerary/itinerary/cn-list/:meeting_id?is_iframe=1'
            }
        },
        // 学术任务管理
        VipProgram: {
            path: '/vip/program/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/program/duty/vip-index/:meeting_id?is_iframe=1'
            }
        },
        // 行程接送管理
        VipScience: {
            path: '/vip/science/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/itinerary/itinerary/cn-science/:meeting_id?is_iframe=1'
            }
        },
        // 住宿信息管理
        VipHotel: {
            path: '/vip/hotel/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/vip/meeting-hotel/cn-index/:meeting_id?is_iframe=1'
            }
        },
        // 工作人员管理
        VipAdmin: {
            path: '/vip/admin/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/itinerary/admin/list/:meeting_id?is_iframe=1'
            }
        },
        // 车辆信息管理
        VipCar: {
            path: '/vip/car/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/itinerary/car/list/:meeting_id?is_iframe=1'
            }
        },
        // 行程参数配置
        VipTripParams: {
            path: '/vip/trip-params/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/itinerary/itinerary/cn-set-trip/:meeting_id?is_iframe=1'
            }
        },
        // 行程签到点配置
        VipTripPlace: {
            path: '/vip/trip-place/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/itinerary/place/list/:meeting_id?is_iframe=1'
            }
        },
        // VIP参数配置
        VipParams: {
            path: '/vip/params/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/vip/set/faculty-config/:meeting_id?is_iframe=1'
            }
        },
        // VIP信息批量设置
        VipBatchInfo: {
            path: '/vip/batch-info/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/vip/user/set-info/:meeting_id?is_iframe=1'
            }
        },
        // 综合数据看板
        VipBoard: {
            path: '/vip/board/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/itinerary/itinerary/data-board/:meeting_id?is_iframe=1'
            }
        },
        // 操作日志管理
        VipLog: {
            path: '/vip/log/:lang/:meeting_id',
            component: () => import('../views/iframe.vue'),
            meta: {
                iframe: domain + '/itinerary/itinerary/search-log-list/:meeting_id?is_iframe=1'
            }
        },
        // 短信群发
        NoticeSmsConfig: {
            path: '/notice/sms-config/:lang/:meeting_id',
            component: () => import('../views/notice-module/message/sms-send.vue')
        },
        // 自定义短信标签
        NoticeSmsTagConfig: {
            path: '/notice/sms-tag-config/:lang/:meeting_id',
            component: () => import('../views/notice-module/message/sms-tag-config.vue')
        },
        // 短信模版配置
        NoticeSmsTemplateConfig: {
            path: '/notice/sms-template-config/:lang/:meeting_id',
            component: () => import('../views/notice-module/message/sms-template-config.vue')
        },
        // 短信发送记录
        NoticeSmsRecord: {
            path: '/notice/sms-record/:lang/:meeting_id',
            component: () => import('../views/notice-module/message/sms-record.vue')
        },
        // 邮件群发
        NoticeEmailConfig: {
            path: '/notice/email-config/:lang/:meeting_id',
            component: () => import('../views/notice-module/email/email-send.vue')
        },
        // 自定义邮件标签
        NoticeEmailTagConfig: {
            path: '/notice/email-tag-config/:lang/:meeting_id',
            component: () => import('../views/notice-module/email/email-tag-config.vue')
        },
        // 邮件模版配置
        NoticeEmailTemplateConfig: {
            path: '/notice/email-template-config/:lang/:meeting_id',
            component: () => import('../views/notice-module/email/email-template-config.vue')
        },
        // 邮件参数配置
        NoticeEmailParamsConfig: {
            path: '/notice/email-params-config/:lang/:meeting_id',
            component: () => import('../views/notice-module/email/email-params-config.vue')
        },
        // 邮件发送记录
        NoticeEmailRecord: {
            path: '/notice/email-record/:lang/:meeting_id',
            component: () => import('../views/notice-module/email/email-record.vue')
        },

        /*********************  论文  **********************/
        // 基础参数配置
        AbstractBaseParams: {
            path: '/submission/abstract-base-params/:lang/:meeting_id',
            component: () => import('../views/submission-module/config/base-params.vue')
        },
        // 稿件支付
        AbstractPaymentParams: {
            path: '/submission/abstract-payment-params/:lang/:meeting_id',
            component: () => import('../views/submission-module/config/payment-params.vue')
        },
        // 类别配置
        AbstractClassParams: {
            path: '/submission/abstract-class-params/:lang/:meeting_id',
            component: () => import('../views/submission-module/config/class-params.vue')
        },
        // 类别配置
        AbstractChannelParams: {
            path: '/submission/abstract-channel-params/:lang/:meeting_id',
            component: () => import('../views/submission-module/config/channel-params.vue')
        },
        // 渠道表单配置
        AbstractChannelFormParams: {
            path: '/submission/abstract-channel-form-params/:lang/:meeting_id',
            component: () => import('../views/submission-module/config/form-params.vue'),
            meta: {
                hide_menu: true
            }
        },
        // 稿件列表
        AbstractList: {
            path: '/submission/abstract-list/:lang/:meeting_id',
            component: () => import('../views/submission-module/list/abstract-list.vue')
        },
        // 论文稿件统计
        AbstractStatistics: {
            path: '/submission/abstract-statistics/:lang/:meeting_id',
            component: () => import('../views/submission-module/statistics-echarts/index.vue')
        },
        // 稿件按类型统计
        AbstractStatisticsTpye: {
            path: '/submission/abstract-statistics-type/:lang/:meeting_id',
            component: () => import('../views/submission-module/statistics/abstract-type.vue')
        },
        // 按第一作者国家
        AbstractStatisticsAuthorCountry: {
            path: '/submission/abstract-statistics-author-country/:lang/:meeting_id',
            component: () => import('../views/submission-module/statistics/author-country.vue')
        },
        // 按第一作者省份
        AbstractStatisticsAuthorProvince: {
            path: '/submission/abstract-statistics-author-province/:lang/:meeting_id',
            component: () => import('../views/submission-module/statistics/author-province.vue')
        },
        // 按第一作者单位
        AbstractStatisticsOrg: {
            path: '/submission/abstract-statistics-author-org/:lang/:meeting_id',
            component: () => import('../views/submission-module/statistics/author-org.vue')
        },
        // 按投稿者省市
        AbstractStatisticsCity: {
            path: '/submission/abstract-statistics-city/:lang/:meeting_id',
            component: () => import('../views/submission-module/statistics/author-city.vue')
        },
        // 按录用类型
        AbstractStatisticsHireType: {
            path: '/submission/abstract-statistics-hire-type/:lang/:meeting_id',
            component: () => import('../views/submission-module/statistics/abstract-hire-type.vue')
        },
        // 推荐单位
        AbstractStatisticsRecommendOrg: {
            path: '/submission/abstract-statistics-recommend-org/:lang/:meeting_id',
            component: () => import('../views/submission-module/statistics/abstract-recommend-org.vue')
        },
        // 论文附件下载
        AbstractDownload: {
            path: '/submission/abstract-download/:lang/:meeting_id',
            component: () => import('../views/submission-module/submission-export/download.vue')
        },
        // 论文稿件导出
        AbstractExprot: {
            path: '/submission/abstract-exprot/:lang/:meeting_id',
            component: () => import('../views/submission-module/submission-export/exprot.vue')
        }
    };
};
